import {Component} from '@angular/core';
import {User} from "@core/shared/models/user";
import {UserService} from "@core/shared/services/user.service";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-core-page-commission-payment-response',
    templateUrl: './page-commission-payment-response.component.html',
    styleUrl: './page-commission-payment-response.component.scss',
    standalone: false
})
export class PageCommissionPaymentResponseComponent {

    public user: User;


    constructor(
        private _activatedRoute: ActivatedRoute,
        private _userService: UserService,
        private _router: Router,
        private _translateService: TranslateService
    ) {}

    ngOnInit() {

        this.user = this._userService.currentUser.value;
    }

    get localeId(): string {

        return this._translateService.currentLang;
    }

    get isSuccess(): boolean {

        return (this._activatedRoute.snapshot.params['response'] === 'success');
    }

    get paymentId(): string {

        return (this._activatedRoute.snapshot.params['reference']);
    }
}
